import React, { useEffect, useState } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import Button from '@mui/material/Button';

const msalConfig = {
  auth: {
    clientId: '26b12ba1-58e4-43ef-9d1a-1dfe922bef73',
    authority: 'https://login.microsoftonline.com/common/oauth2/v2.0/',
    redirectUri: 'https://cipilotv2.lexai.nativeorange.ai/'
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

const MicrosoftSSO = ({ setMicrosoftUser }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('userDetails');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    if (window.opener) {
      const userFromPopup = localStorage.getItem('userDetails');
      if (userFromPopup) {
        window.opener.postMessage(
          { type: 'MICROSOFT_LOGIN_SUCCESS', user: JSON.parse(userFromPopup) },
          '*'
        );
        window.close();
      }
    }
  }, []);

  const loginWithMicrosoft = async () => {
    try {
      await msalInstance.initialize(); // Ensure MSAL instance is initialized
      const loginResponse = await msalInstance.loginPopup({
        scopes: ['User.Read']
      });
      const userData = {
        name: loginResponse.account.name,
        email: loginResponse.account.username
      };

      console.log(loginResponse, 'The login response from Microsoft');

      setUser(userData);
      localStorage.setItem('userDetails', JSON.stringify(userData));

      setMicrosoftUser({
        email: 'testuser',
        password: 'Python@123'
      });

      if (window.opener) {
        window.opener.postMessage(
          { type: 'MICROSOFT_LOGIN_SUCCESS', user: userData },
          '*'
        );
        window.close();
      }
    } catch (error) {
      console.error('Error during Microsoft login:', error);
    }
  };

  const logout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <div className='text-center mt-5'>
      <Button
        type='submit'
        variant='contained'
        onClick={loginWithMicrosoft}
        style={{
          backgroundColor: 'grey',
          color: '#000',
          pointerEvents: 'none',
          border: 'solid 1px #ccc',
          cursor: 'not-allowed',
          boxShadow: 'none',
          textTransform: 'capitalize'
        }}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          fill='currentColor'
          className='bi bi-microsoft'
          viewBox='0 0 16 16'
        >
          <path d='M7.462 0H0v7.19h7.462V0zM16 0H8.538v7.19H16V0zM7.462 8.211H0V16h7.462V8.211zm8.538 0H8.538V16H16V8.211z' />
        </svg>
        &nbsp; Login with Microsoft
      </Button>
    </div>
  );
};

export default MicrosoftSSO;
